import React, { createContext, useEffect, useState } from "react";

export const TimezoneContext = createContext();

export const TimezoneProvider = ({ children }) => {
  const [timezone, setTimezoneState] = useState("UTC");

  const setTimezone = (value) => {
    const tz =
      typeof value === "object" && value?.value
        ? value.value
        : typeof value === "string"
        ? value
        : "UTC";
    setTimezoneState(tz);
    localStorage.setItem("timezone", tz); 
  };

  useEffect(() => {
    try {
      const saved = localStorage.getItem("timezone");
      if (saved) {
        const parsed =
          saved.startsWith("{") && saved.endsWith("}")
            ? JSON.parse(saved)?.value || "UTC"
            : saved;
        setTimezoneState(parsed);
      }
    } catch (err) {
      console.error("Error loading timezone from localStorage", err);
      setTimezoneState("UTC");
    }
  }, []);

  return (
    <TimezoneContext.Provider value={{ timezone, setTimezone }}>
      {children}
    </TimezoneContext.Provider>
  );
};
